import {
  FilterCheckbox,
  translateServices,
  useOrderedServices,
} from "@repo/ui";
import { hasItems, isChecked } from "@repo/utils";

import { FilterListContainer } from "./FilterListContainer";
import { type FilterItemsProps } from "./type";

export const InterestedServiceFilter = ({
  actions,
  filters,
}: FilterItemsProps) => {
  const services = useOrderedServices();

  return (
    <FilterListContainer id="interested-service-filter">
      {hasItems(services) &&
        services.map(([key, value]) => (
          <FilterCheckbox
            key={key}
            id={Number(key)}
            value={String(key)}
            label={translateServices(value) ?? "-"}
            checked={isChecked(filters.services, Number(key))}
            onCheckFilter={actions.setServices}
          />
        ))}
    </FilterListContainer>
  );
};
